import { z } from "zod";
import { int, isoDate, lenientArray, strings, text } from "./common";

/** The four wedge categories a consultation can be framed around. */
export const CONSULT_CATEGORIES = [
  "decision_intelligence",
  "couples_compatibility",
  "diaspora_vedic",
  "lal_kitab",
] as const;
export type ConsultCategory = (typeof CONSULT_CATEGORIES)[number];

export const CONSULT_CATEGORY_LABEL: Readonly<Record<ConsultCategory, string>> = {
  decision_intelligence: "Decision Intelligence",
  couples_compatibility: "Couples Compatibility",
  diaspora_vedic: "Western-Vedic Bridge",
  lal_kitab: "Lal Kitab",
};

/** `POST /consult/turn` */
export const consultAnswerSchema = z.object({
  answer: text(),
  balance_after: int(),
  facts_used: strings(),
});
export type ConsultAnswer = Readonly<z.output<typeof consultAnswerSchema>>;

export const memoryFactSchema = z.object({
  id: int(),
  fact: text(),
  created_at: isoDate(),
});
export type MemoryFact = Readonly<z.output<typeof memoryFactSchema>>;

export const memoryListSchema = z.object({ facts: lenientArray(memoryFactSchema) });

/** `POST /voice/token`: where to connect and as whom. */
export const voiceTokenSchema = z.object({
  url: z.string().min(1),
  token: z.string().min(1),
  room_name: text(),
});
export type VoiceToken = Readonly<z.output<typeof voiceTokenSchema>>;

export const preferencesSchema = z.object({ language: text() });

export const tarotReadingSchema = z.object({
  cards: lenientArray(z.object({ reading: text() })),
});

export interface TarotCardDraw {
  readonly name: string;
  readonly reversed: boolean;
  readonly position: string;
}
